import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { log } from "../../utils/logger";
import "./Anketa.css";

export const ForgotPassword = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [fieldErrors, setFieldErrors] = useState<Record<string, string>>({});
    const [message, setMessage] = useState<{ type: "success" | "error"; text: string } | null>(null);
    const [endpointAddress, setEndpointAddress] = useState("");
    const [submitting, setSubmitting] = useState(false);

    useEffect(() => {
        fetch("/config.json")
            .then((res) => res.json())
            .then((config) => {
                if (config["endpoint-address"]) setEndpointAddress(config["endpoint-address"]);
                log("ForgotPassword", "Загружен config", { hasEndpoint: !!config["endpoint-address"] });
            })
            .catch((err) => log("ForgotPassword", "Ошибка загрузки config", err));
    }, []);

    const validate = (): Record<string, string> => {
        const err: Record<string, string> = {};
        if (!email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) err.email = "Введите корректный email";
        return err;
    };

    const handleSubmit = async () => {
        setMessage(null);
        const errors = validate();
        setFieldErrors(errors);
        if (Object.keys(errors).length > 0) {
            log("ForgotPassword", "Валидация не пройдена", errors);
            return;
        }
        if (!endpointAddress) {
            setMessage({ type: "error", text: "Сервис временно недоступен." });
            return;
        }

        log("ForgotPassword", "Запрос сброса пароля", { email: email.trim() });
        setSubmitting(true);
        try {
            const res = await fetch(`${endpointAddress}/requestPasswordReset`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ email: email.trim() }),
            });
            const data = await res.json().catch(() => ({}));
            log("ForgotPassword", "Ответ сервера", { status: res.status, data });

            if (data.status === "1" && data.message) {
                setMessage({ type: "success", text: data.message });
                return;
            }
            if (data.code === "Error") {
                setMessage({ type: "error", text: "Ошибка запроса. Попробуйте позже." });
                return;
            }
            setMessage({ type: "success", text: "Если аккаунт с таким email зарегистрирован и подтверждён, на него отправлена ссылка для сброса пароля." });
        } catch (err) {
            log("ForgotPassword", "Ошибка соединения", err);
            setMessage({ type: "error", text: "Ошибка соединения. Попробуйте позже." });
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div className="anketa-container">
            <div className="register-card">
                <div className="question-section">
                    <h2 className="question-text">Сброс пароля</h2>
                    <p className="question-hint">Введите email вашего аккаунта. Мы отправим ссылку для сброса пароля.</p>
                </div>

                <div className="form-section">
                    <div className="form-group">
                        <label>Email</label>
                        <input
                            type="text"
                            value={email}
                            placeholder="example@example.com"
                            onChange={(e) => setEmail(e.target.value)}
                        />
                        {fieldErrors.email && <div className="field-error">{fieldErrors.email}</div>}
                    </div>
                    {message && (
                        <div
                            className="field-error"
                            style={{
                                marginTop: "0.5rem",
                                color: message.type === "success" ? "var(--success, #22c55e)" : "var(--error)",
                            }}
                        >
                            {message.text}
                        </div>
                    )}
                </div>

                <div className="navigation-section">
                    <button className="nav-btn prev-btn" onClick={() => navigate("/login")} type="button">
                        ← Назад к входу
                    </button>
                    <button
                        className="nav-btn submit-btn"
                        onClick={handleSubmit}
                        type="button"
                        disabled={submitting}
                    >
                        {submitting ? "Отправка..." : "Отправить ссылку"}
                    </button>
                </div>
            </div>
        </div>
    );
};
